
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const AcceptanceSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Acceptance of Terms</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-gray-700">
        By accessing and using SocialScoop ("the Service"), you accept and agree to be bound by the terms 
        and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
      </p>
    </CardContent>
  </Card>
);

export const ServiceDescriptionSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Description of Service</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          SocialScoop helps you diminish the noise and amplify what matters 
          for a healthier social media experience. Our service allows users to:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>Connect their social media accounts via OAuth</li>
          <li>Create custom filtering rules for content</li>
          <li>Block specific keywords, users, and hashtags</li>
          <li>Filter content based on sentiment analysis</li>
          <li>Manage multiple social media platforms from one dashboard</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);

export const UserAccountsSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>User Accounts and Registration</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          To use certain features of our Service, you must register for an account. When you register:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>You must provide accurate and complete information</li>
          <li>You are responsible for maintaining the security of your account</li>
          <li>You must notify us immediately of any unauthorized use</li>
          <li>You are responsible for all activities under your account</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);

export const SocialMediaIntegrationSection = () => (
  <Card>
    <CardHeader>
      <CardTitle>Social Media Integration</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-gray-700">
        <p>
          Our Service integrates with various social media platforms through official APIs and OAuth protocols:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>We only access data you explicitly authorize</li>
          <li>We do not store your social media passwords</li>
          <li>You can revoke access at any time through your account settings</li>
          <li>We comply with each platform's terms of service and API usage policies</li>
        </ul>
      </div>
    </CardContent>
  </Card>
);
